import { styled, Typography } from '@mui/material';
import { FC } from 'react';

const WarningSection = styled('div')`
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing(1, 3)};
  background: ${({ theme }) => theme.palette.background.paper};
  text-align: center;
`;

const WarningText = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 0.75rem;
`;

export const DisclaimerWarning: FC = () => {
  return (
    <WarningSection>
      <WarningText>AI can make mistakes - double check information.</WarningText>
    </WarningSection>
  );
};
